import {} from '@tanstack/query-core';
import { switchChain, } from '../actions/switchChain.js';
import {} from '../createConfig.js';
import {} from '../types/utils.js';
export function switchChainMutationOptions(config) {
    return {
        mutationFn(variables) {
            return switchChain(config, variables);
        },
        mutationKey: ['switchChain'],
    };
}
//# sourceMappingURL=switchChain.js.map